import { Helmet } from "react-helmet-async"
import "./layout.css"
import { SegmentPageTracker } from "../lib/SegmentPageTracker"

export const Head = () => {
  return (
    <>
      <SegmentPageTracker />
      <Helmet>
        <link rel="preconnect" href="https://cerebral.prismic.io" />
        <link rel="preconnect" href="https://utt.impactcdn.com" />
        <link rel="preconnect" href="https://fast.ssqt.io" />
        <link rel="preconnect" href="https://cdn.segment.com" />
        <link rel="preconnect" href="https://cdn.heapanalytics.com" />
        <link rel="preconnect" href="https://images.prismic.io" crossorigin />
        <link rel="dns-prefetch" href="https://images.prismic.io" />
        <link
          rel="preconnect"
          href="https://rum.browser-intake-datadoghq.com"
        />
        <script type="text/javascript">{`
                  if (sessionStorage.getItem("gatsby-reload-compilation-hash-match") === "1" && !window.location.href.includes("?nocache=")) {
                    window.location.href =
                      window.location.href.split("?")[0] + "?nocache=" + new Date().getTime()
                  }
              `}</script>
      </Helmet>
      <Helmet>
        <script async type="text/javascript">
          {`(function(a,b,c,d,e,f,g){e['ire_o']=c;e[c]=e[c]||function(){(e[c].a=e[c].a||[]).push(arguments)};f=d.createElement(b);g=d.getElementsByTagName(b)[0];f.async=1;f.src=a;g.parentNode.insertBefore(f,g);})('https://utt.impactcdn.com/A2435171-ef85-4e75-a435-a531a42fbce31.js','script','ire',document,window);`}
        </script>
      </Helmet>
    </>
  )
}

export default Head
